import type { MailboxInfo } from 'owa-client-ids';
import type AttachmentPreview from 'owa-service/lib/contract/AttachmentPreview';
import type GetAttachmentPreviewsResponse from 'owa-service/lib/contract/GetAttachmentPreviewsResponse';
import getAttachmentPreviewsService from './getAttachmentPreviewsService';
import type ItemId from 'owa-service/lib/contract/ItemId';
import { getMailboxRequestOptions } from 'owa-request-options-types';

export async function getAttachmentPreviewForConversations(
    mailboxInfo: MailboxInfo,
    conversationIds: ItemId[]
): Promise<{ [key: string]: AttachmentPreview[] }> {
    const responseMap: { [key: string]: AttachmentPreview[] } = {};

    try {
        const response: GetAttachmentPreviewsResponse = await getAttachmentPreviewsService(
            conversationIds,
            getMailboxRequestOptions(mailboxInfo),
            {
                FullPreviewsPerConversation: 300,
                PreviewsPerConversation: 300,
                MinimumAttachmentSize: 0,
                IncludeInlineAttachments: false,
            }
        );

        if (!!response.Conversations) {
            response.Conversations.forEach(conversation => {
                if (
                    conversation?.ConversationId &&
                    conversation.AttachmentPreviews &&
                    conversation.AttachmentPreviews.Previews
                ) {
                    const attachmentPreviews: AttachmentPreview[] = [];

                    const filteredPreviews = getFilteredPreviews(
                        conversation.AttachmentPreviews.Previews
                    );

                    filteredPreviews.forEach(preview => {
                        if (preview.Attachment) {
                            attachmentPreviews.push(preview);
                        }
                    });

                    responseMap[conversation.ConversationId.Id] = attachmentPreviews;
                }
            });
        }
    } catch (error) {
        // TODO do we need to do any cleanup or error checking here?
    }

    return responseMap;
}

function getFilteredPreviews(previews: AttachmentPreview[]): AttachmentPreview[] {
    // If the preview has no name, we should not show on the UI
    const validPreviews = previews.filter(isValidPreview);
    return validPreviews;
}

function isValidPreview(preview: AttachmentPreview): boolean {
    return !!preview.Attachment?.Name;
}
